'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var slideInLeft = {
  from: {
    transform: (0, _utils.translate3d)('-100%', 0, 0),
    visibility: 'visible'
  },
  to: {
    transform: (0, _utils.translate3d)(0, 0, 0)
  }
};
exports.default = slideInLeft;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/slide-in-left.js
// module id = 256
// module chunks = 54990529738226 257444579329143